<template>
    <crud-create :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @create="create"
                 @close="$emit('close')"
    >
        <daily-box-form ref="form" v-model="form" :input-errors="inputErrors" @save="create" />
    </crud-create>
</template>

<script>

    import DailyBoxProvider from "../../../../providers/DailyBoxProvider";
    
    import {CrudCreate, ClientError} from '@dracul/common-frontend'
    
    import DailyBoxForm from "../../../../forms/DailyBoxForm";
    
    


    export default {
        name: "DailyBoxCreate",
         
        components: { DailyBoxForm, CrudCreate },
        
        props:{
          open: {type: Boolean, default: true}
        },
        
        data() {
            return {
                title: 'delivery.dailyBox.creating',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                form: {
                    boxDate: null,
                    shift: '',
                    rows: ''
                }
            }
        },
        
        methods: {
            create() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    DailyBoxProvider.createDailyBox(this.form).then(r => {
                            if (r) {
                                this.$emit('itemCreated',r.data.createDailyBox)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }

        },
    }
</script>

<style scoped>

</style>

